// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const endpoint = {
  apiUrl: "#{apiUrl}#",
  apiRoute: "#{apiRoute}#",
  documentApiUrl: "#{documentApiUrl}#",
  gestionOtpUrl: "#{gestionOtpUrl}#",
  listarPolizas: "#{listarPolizas}#",
  listarDetalles: "#{listarDetalles}#",
  registrarFirma: "#{registrarFirma}#",
  generarOtp: "#{generarOtp}#",
  validarOtp: "#{validarOtp}#"
}

export const msal={
  messageId: 'cf5e04d7-519b-4834-ab75-3b02f7389f84',
  clientId: "978d42086063e381ed99193f2011c9fd",
  apiKey: "QmSi9ECEplMweM2rKz27IpzcOl6DWNmIHbZ8Y20MPmvRynDgmf6u15dTk6sylTY6"
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
